import { memo } from 'react'
import { Icon } from '@campgladiator/cgui-core.atoms.icon'
import styles from './CloseButtonWithCountdown.module.scss'

type CloseButtonProps = {
  totalSeconds: number
  secondsRemaining: number
  onCloseButtonClick?: () => void
}

type TimeCalculationParams = {
  secondsRemaining: number
  totalSeconds: number
}

const radius = 45
const arcLength = Math.floor(radius * Math.PI * 2)
const pathData = 'M 50, 50 m -45, 0 a 45,45 0 1,0 90,0 a 45,45 0 1,0 -90,0'

const calculateTimeFraction = ({
  secondsRemaining,
  totalSeconds,
}: TimeCalculationParams): number => (secondsRemaining - 1) / totalSeconds

const arcLengthRemaining = ({
  secondsRemaining,
  totalSeconds,
}: TimeCalculationParams): number =>
  Math.floor(
    calculateTimeFraction({ secondsRemaining, totalSeconds }) * arcLength,
  )

const CloseButtonWithCountdown = ({
  totalSeconds,
  secondsRemaining,
  onCloseButtonClick = () => {},
}: CloseButtonProps) => (
  <div className={styles.baseTimer} onClick={onCloseButtonClick}>
    <svg
      className={styles.svg}
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g className={styles.circle}>
        <circle className={styles.pathElapsed} cx="50" cy="50" r={radius} />
        <path
          strokeDasharray={`${arcLengthRemaining({
            secondsRemaining,
            totalSeconds,
          })}, ${arcLength}`}
          className={styles.pathRemaining}
          d={pathData}
        ></path>
      </g>
    </svg>
    <Icon name="icon-times-line" className={styles.icon} />
  </div>
)

export default memo(CloseButtonWithCountdown)
